import { render, staticRenderFns } from "./ResultsProposition.vue?vue&type=template&id=a0afa522&"
import script from "./ResultsProposition.vue?vue&type=script&lang=js&"
export * from "./ResultsProposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports